var Vue = require('vue');
var DataTable = require('./datatable.js');
var ExportActionDropdown = require('./components/Exports/ExportActionDropdown.vue').default;

/**
 * Setup base components on the index view.
 *
 * Usage:
 *   new IndexView();
 *
 */
module.exports = function () {
  var datatable = new DataTable;

  datatable.setup('.datatable');

  $('.filtertron-tray').filtertronTray({
    onOpen: function () {
      datatable.refresh();
    },
    onClose: function () {
      datatable.refresh();
    }
  });

  $(document).one('pjax:end', () => {
    datatable.refresh();
  });

  var exportActionButton = document.getElementById('export-action');

  if (exportActionButton) {
    new Vue({
      el: exportActionButton,
      components: {
        'export-action-dropdown': ExportActionDropdown
      }
    });
  }
};
